import { useEffect, useState } from "react";
import uploadManager, { UploadTask } from "../services/uploadManager";

interface UploadProgress {
  status: UploadTask["status"] | null;
  progress: number;
  error?: string;
}

export default function useUploadProgress(
  taskId: string | number | null | undefined
): UploadProgress {
  const [state, setState] = useState<UploadProgress>({
    status: null,
    progress: 0,
  });

  useEffect(() => {
    if (!taskId) return;

    const id = String(taskId);
    const task = uploadManager.getTask(id);
    if (task) {
      setState({ status: task.status, progress: task.progress, error: task.error });
    }

    const unsub = uploadManager.subscribe(id, (t) => {
      setState({ status: t.status, progress: t.progress, error: t.error });
    });

    return unsub;
  }, [taskId]);

  return state;
}
